import { useContext } from 'react'
import { Link } from 'react-router-dom'
import Translate from '../../i18n/Translate'
import { useTranslation } from 'react-i18next'
import { I18nContext } from '../../context/I18nProvider'
import { ItinerariesContext } from '../../context/ItinerariesProvider'
//Intersection
import { useInView } from 'react-intersection-observer'
//Placeholder
import placeholder_768 from '../../assets/images/placeholders/placeholder_768x768.jpg'

const ItineraryCard = ({ itinerary }) => {
    const { t } = useTranslation()
    const { language } = useContext(I18nContext)
    const { setSelectedItinerarieID } = useContext(ItinerariesContext)

    const { id, title, slug, days, nights, places, thumbnail } = itinerary

    const [cardViewRef, inView] = useInView({
        threshold: 1,
        rootMargin: '-50px 0px',
    })

    return (
        <Link
            to={`/${language}${t('routes.itinerary_detail')}/${slug}`}
            className={`itinerary-card ${inView ? 'in-view' : ''}`}
            role="button"
            tabIndex={0}
            ref={cardViewRef}
            onClick={() => setSelectedItinerarieID(id)}
        >
            <div className="itinerary-card__content">
                <h4>{title}</h4>
                <p>
                    {days} {days > 1 ? <Translate langkey="commons.days" /> : <Translate langkey="commons.day" />} /{' '}
                    {nights} {days > 1 ? <Translate langkey="commons.nights" /> : <Translate langkey="commons.night" />}
                </p>
                <small>{places.join(' - ')}</small>
            </div>

            <div className="itinerary-card__img-wrapper">
                {/* Si no hay imagen thumbnail dada mostramos un placeholder de tower */}
                {!thumbnail.length && <img src={placeholder_768} alt={title} />}
                {/* Si solo hay una imagen renderizamos una etiqueta img simple */}
                {thumbnail.length === 1 && <img src={thumbnail[0]} alt={title} />}
                {/* Si hay mas de una imagen renderizamos una etiqueta img con un srcSet */}
                {thumbnail.length > 1 && (
                    <img
                        src={thumbnail[0]}
                        srcSet={`${thumbnail[0]} 1x, ${thumbnail[1]} 2x, ${thumbnail[1]} 3x`}
                        alt={title}
                    />
                )}
            </div>
            <div className="itinerary-card__filter-layer"></div>
            <div className="itinerary-card__lying-triangle"></div>
        </Link>
    )
}

export default ItineraryCard
